const NAME = "PAYMENT_TYPES";

export default NAME;
